export default class LeadsEditableFieldType {
  constructor(id, name) {
    this.name = name;
    this.id = id;
  }

  getName() {
    return this.name;
  }

  getId() {
    return this.id;
  }
}

// 与服务端code一一对应，id对应 OperationTypeEnum 中的 value ，name对应查询接口中的请求参数名
LeadsEditableFieldType.NAME = new LeadsEditableFieldType(1, 'name');
LeadsEditableFieldType.TEL = new LeadsEditableFieldType(4, 'tel');
LeadsEditableFieldType.AREA = new LeadsEditableFieldType(3, 'area');
LeadsEditableFieldType.SEX = new LeadsEditableFieldType(2, 'sex');
LeadsEditableFieldType.EMAIL = new LeadsEditableFieldType(5, 'email');
LeadsEditableFieldType.INTENTION = new LeadsEditableFieldType(6, 'intention');
LeadsEditableFieldType.QQ = new LeadsEditableFieldType(8, 'qq');
LeadsEditableFieldType.WECHAT = new LeadsEditableFieldType(9, 'wechat');
LeadsEditableFieldType.MEMO = new LeadsEditableFieldType(12, 'memo');
LeadsEditableFieldType.FOLLOW_TAG = new LeadsEditableFieldType(13, 'followTag');
LeadsEditableFieldType.BUNDLES = new LeadsEditableFieldType(14, 'bundle');
LeadsEditableFieldType.CONTACT = new LeadsEditableFieldType(15, 'contact');

LeadsEditableFieldType.ownerName = new LeadsEditableFieldType(51, 'ownerName');

LeadsEditableFieldType.AGE = new LeadsEditableFieldType(28, 'age');
LeadsEditableFieldType.PROFESSION = new LeadsEditableFieldType(23, 'profession');
LeadsEditableFieldType.WORKING_YEARS = new LeadsEditableFieldType(24, 'workingYears');
LeadsEditableFieldType.ID_NUMBER = new LeadsEditableFieldType(25, 'idNumber');
LeadsEditableFieldType.ADDRESS = new LeadsEditableFieldType(26, 'address');
LeadsEditableFieldType.NATIONALITY = new LeadsEditableFieldType(27, 'nationality');

LeadsEditableFieldType.CAMPAGIN_ID = new LeadsEditableFieldType(61, 'campaignId');
LeadsEditableFieldType.CAMPAGIN_NAME = new LeadsEditableFieldType(62, 'campaignName');
LeadsEditableFieldType.AD_ID = new LeadsEditableFieldType(63, 'adId');
LeadsEditableFieldType.AD_NAME = new LeadsEditableFieldType(64, 'adName');
LeadsEditableFieldType.CREATIVE_ID = new LeadsEditableFieldType(65, 'creativeId');
LeadsEditableFieldType.CREATIVE_NAME = new LeadsEditableFieldType(66, 'creativeName');

// 前端特有的code
LeadsEditableFieldType.LEAD_ID = new LeadsEditableFieldType(996, 'leadsId');
LeadsEditableFieldType.PAGE_ID = new LeadsEditableFieldType(997, 'pageId');
LeadsEditableFieldType.FOLLOW = new LeadsEditableFieldType(998, 'follow');
LeadsEditableFieldType.BUNDLE = new LeadsEditableFieldType(999, 'bundle');
LeadsEditableFieldType.COMPONENT_ID = new LeadsEditableFieldType(1000, 'componentId');
LeadsEditableFieldType.COMPONENT_NAME = new LeadsEditableFieldType(1001, 'componentName');
LeadsEditableFieldType.CUSTOMIZED_ATTRIBUTE = new LeadsEditableFieldType(1002, 'customizedAttribute');
LeadsEditableFieldType.SOURCE_ACCOUNT_ID = new LeadsEditableFieldType(1003, 'sourceAccountIdsStr');

Object.freeze(LeadsEditableFieldType);
